import { default as S } from "react-loading-skeleton"
import { SkeletonProps } from "react-loading-skeleton/dist/Skeleton"
import "react-loading-skeleton/dist/skeleton.css"
import tinycolor from "tinycolor2"

const Skeleton = (props: SkeletonProps) => (
  <S
    containerClassName={"rounded-none"}
    borderRadius={0}
    baseColor={"#2D3036"}
    highlightColor={tinycolor("#2D3036").lighten(5).toString()}
    {...props}
  />
)

export default Skeleton
